class ProductVideoAutoplay extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video, iframe[src*="youtube"], iframe[src*="vimeo"]');
    this.setupVideoHandling();
  }

  setupVideoHandling() {
    // Handle visibility changes
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      });
    }, { threshold: 0.5 });

    this.videos.forEach(video => {
      observer.observe(video);
    });
  }

  playVideo(video) {
    if (video.tagName === 'VIDEO') {
      // Play with muted (browsers allow muted autoplay)
      video.muted = true;
      video.play().catch((error) => {
        // Handle autoplay failure (e.g., browser policy)
      });
    } else if (video.tagName === 'IFRAME') {
      // For YouTube/Vimeo iframes, we need to use their respective APIs
      if (video.src.includes('youtube')) {
        this.playYouTubeVideo(video);
      } else if (video.src.includes('vimeo')) {
        this.playVimeoVideo(video);
      }
    }
  }

  pauseVideo(video) {
    if (video.tagName === 'VIDEO') {
      video.pause();
    } else if (video.tagName === 'IFRAME') {
      if (video.src.includes('youtube')) {
        this.pauseYouTubeVideo(video);
      } else if (video.src.includes('vimeo')) {
        this.pauseVimeoVideo(video);
      }
    }
  }

  playYouTubeVideo(iframe) {
    // YouTube API requires the video to be loaded with enablejsapi=1
    if (!iframe.src.includes('enablejsapi=1')) {
      iframe.src = iframe.src + (iframe.src.includes('?') ? '&' : '?') + 'enablejsapi=1';
    }
    iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }

  pauseYouTubeVideo(iframe) {
    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }

  playVimeoVideo(iframe) {
    iframe.contentWindow.postMessage('{"method":"play"}', '*');
  }

  pauseVimeoVideo(iframe) {
    iframe.contentWindow.postMessage('{"method":"pause"}', '*');
  }
}

customElements.define('product-video-autoplay', ProductVideoAutoplay); 